import {
	LeadFormTypes,
	RadioInputOptionTypes,
	RadioInputType,
} from '../../../../types/components'
import selectedIcon from '../../../../asset/selectedIcon.png'
import nonSelectedIcon from '../../../../asset/nonselectedIcon.png'
import {
	RadioInputGroup,
	RadioInputOption,
	RadioInputOptionText,
	RadioImageInput,
} from './styles'

const RadioInput = ({
	formValues,
	handleChange,
	options = [],
}: RadioInputType) => {
	return (
		<RadioInputGroup
			onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e)}
		>
			{options.map(({ name, label, value, id }: RadioInputOptionTypes) => (
				<RadioInputOption key={id}>
					<RadioImageInput
						type="radio"
						name={name}
						value={value}
						id={id}
					/>
					<RadioInputOptionText
						isSelected={formValues[name as keyof LeadFormTypes] === value}
					>
						{label}
					</RadioInputOptionText>
					{formValues[name as keyof LeadFormTypes] === value ? (
						<img src={selectedIcon} alt="selected" />
					) : (
						<img src={nonSelectedIcon} alt="nonselected" />
					)}
				</RadioInputOption>
			))}
		</RadioInputGroup>
	)
}

export default RadioInput
